import { render, staticRenderFns } from "./RadioLegend.vue?vue&type=template&id=397f7076&scoped=true&"
import script from "./RadioLegend.vue?vue&type=script&lang=ts&"
export * from "./RadioLegend.vue?vue&type=script&lang=ts&"
import style0 from "./RadioLegend.vue?vue&type=style&index=0&id=397f7076&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "397f7076",
  null
  
)

export default component.exports